// Quiz de la variante « faible énergie » (R-SES-10) : 3 à 5 questions à choix, correction immédiate.
import { useState } from 'react';

export interface QuestionQuiz { question: string; choix: string[]; bonne: number; explication: string }

export function Quiz({ questions, auTerme }: { questions: QuestionQuiz[]; auTerme?: (score: number) => void }) {
  const [reponses, setReponses] = useState<Record<number, number>>({});
  const score = questions.filter((q, i) => reponses[i] === q.bonne).length;
  const fini = Object.keys(reponses).length === questions.length;
  return (
    <div className="quiz">
      {questions.map((q, i) => (
        <div key={i} style={{ marginBottom: '1em' }}>
          <p><strong>{i + 1}. {q.question}</strong></p>
          {q.choix.map((c, j) => {
            const choisi = reponses[i];
            const classe = choisi === undefined ? '' : j === q.bonne ? 'bon' : j === choisi ? 'mauvais' : '';
            return (
              <label key={j} className={`choix ${classe}`}>
                <input type="radio" name={`q${i}`} disabled={choisi !== undefined} checked={choisi === j} onChange={() => setReponses((r) => ({ ...r, [i]: j }))} />
                {c}
              </label>
            );
          })}
          {reponses[i] !== undefined ? <p className="petit-texte doux">{reponses[i] === q.bonne ? '✓ Exact. ' : '✗ '}{q.explication}</p> : null}
        </div>
      ))}
      {fini ? <div className="message ok">Score : {score} / {questions.length}. {auTerme ? <button className="petit" onClick={() => auTerme(score)}>Continuer</button> : null}</div> : null}
    </div>
  );
}
